import React, {Component} from 'react'

class LinkedTextArea extends Component {
  constructor (props) {
    super(props)
    this.state = {
      value: this.getValueFromPath(this.props.path),
      editable: (props.editable) ? props.editable : true,
      rows: (props.rows) ? props.rows : 1
    }
  }

  getValueFromPath (path) {
    var obj = this.props.context.state
    var stack = path.split('.')
    while (stack.length) {
      obj = obj[stack.shift()]
    }
    return obj
  }

  setValueAtPath (path, value) {
    var obj = this.props.context.state
    var current = obj
    var stack = path.split('.')
    while (stack.length > 1) {
      current = current[stack.shift()]
    }
    current[stack.shift()] = value
    return obj
  }

  componentWillReceiveProps (props) {
    if (this.state.value === this.getValueFromPath(this.props.path) && this.state.editable === props.editable) {
      return false
    }
    this.setState({
      editable: (props.editable) ? props.editable : true,
      value: this.getValueFromPath(this.props.path)
    })
  }

  validate () {
    if (!this.props.validate) return true
    return !!(((this.type.prototype.getValueFromPath.call(this, this.propss.path)) + ''.match(this.props.validate)))
  }

  handleChange (e) {
    this.props.context.setState(this.setValueAtPath(this.props.path, e.target.value || (this.props.nullable ? null : '')))
    var value = this.getValueFromPath(this.props.path)
    var rows = this.state.rows
    if (this.props.resize) {
      rows = value.split('\n').length
    }
    this.setState({
      value: value,
      rows: rows > 20 ? 20 : rows
    })
    // this.props.context.forceUpdate()
  }

  render () {
    return (
      <div className={this.props.path.replace(/\./g, '-') + ' linked-textarea-wrapper'}>
        <textarea
          key={this.props.path.replace(/\./g, '-')}
          name={this.props.name || ''}
          disabled={(this.props.hasOwnProperty('editable') ? (this.props.editable ? false : true) : false)}
          onChange={(e) => {
            this.handleChange(e)
            if (this.props.onChange) this.props.onChange(e)
          }}
          onKeyUp={(e) => {
            this.handleChange(e)
            if (this.props.onChange) this.props.onChange(e)
          }}
          onKeyDown={(e) => {
            if (this.props.onKeyDown) this.props.onKeyDown(e)
          }}
          value={this.state.value}
          className={'form-control ' + (this.props.className || '') + (this.props.button ? ' linkedtextarea-with-button' : '')}
          placeholder={this.props.placeholder}
          cols={this.props.cols ? this.props.cols : 50}
          rows={this.state.rows}
          style={{'resize': (this.props.resize ? this.props.resize : 'vertical')}}
       />
        {this.props.button && <button disabled={this.props.button.disabled} className={(this.props.button.hidden ? 'hidden' : 'btn btn-primary linkedinput-callback-button')} onClick={() => this.props.button.callback()}><i className={'fa fa-fw ' + this.props.button.icon} /></button>}
        <span className={'error-message ' + this.props.errorMessage ? '' : 'hidden'}>{this.props.errorMessage}</span>
      </div>
    )
  }
}
export default LinkedTextArea



// WEBPACK FOOTER //
// ./src/components/basic/inputs/LinkedTextArea.js